import { connect } from 'react-redux';
import {
  installerFiles as installerFileActions,
  modal as modalActions,
} from '../actions';
import PropTypes from 'prop-types';
import ConfirmationModalComponent
  from '../Components/ConfirmationModalComponent';
import { owners } from '../helpers/modals';
import { USER_KEY } from '../helpers/storage';
import { getModalVisibility } from './../reducers';

export const mapStateToProps = (state) => {
  const visible = getModalVisibility(state, owners.acknowledgeTests);
  const title = 'Confirm Acknowledge Tests';
  const confirmText = 'Confirm';
  const cancelText = 'Cancel';
  const bodyText = 'This will set the current test result as ' +
    'the expected result for all future runs of the test!';
  return {
    visible,
    title,
    confirmText,
    cancelText,
    bodyText
  };
};

export const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    onCancel: () => dispatch(modalActions.showAcknowledgeTestsModal(false)),
    onConfirm: () => {
      ownProps.expected.forEach(result =>
        dispatch(installerFileActions.setInstallerExpectedFile(
          result.filename, result.presenceId, result.expected,
          localStorage.getItem(USER_KEY) || '')));
      ownProps.submitCallback();
      dispatch(modalActions.showAcknowledgeTestsModal(false)); }
  };
};

const AcknowledgeTestsModalContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
)(ConfirmationModalComponent);

AcknowledgeTestsModalContainer.propTypes = {
  visible: PropTypes.func,
  title: PropTypes.string,
  confirmText: PropTypes.string,
  cancelText: PropTypes.string,
  bodyText: PropTypes.string,
};

export default AcknowledgeTestsModalContainer;


// WEBPACK FOOTER //
// src/Containers/AcknowledgeTestsModalContainer.jsx